var map = {
	"./bahaw1.png": 3669,
	"./bahaw2.png": 6942,
	"./bahaw3.png": 2727,
	"./bahaw4.png": 3112,
	"./bahaw5.png": 1505,
	"./bahaw6.png": 1610,
	"./bahaw7.png": 1443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5875;